import React, { useState, useEffect, useContext, useRef } from "react";
import { createContext } from "react";
import { useNavigate } from "react-router-dom";
import { useCuestionario } from "../hooks/useCuestionario.js";
import { useUser } from "../hooks/useUser";
import { GeneralContext } from "./GeneralContext.jsx";
import { useTranslation } from 'react-i18next';
export const MisCuestionariosContext = createContext();



//nombre del componente que va a englobar a todos
export function MisCuestionariosContextProvider(props) {
    const { user, isLogged, logout } = useUser();
    const navigate = useNavigate();
    const { getCuestionarioActual, getCuestionarosHistoricos } = useCuestionario();
    const [perfilesEmpresarialesHistoricos, setPerfilesEmpresarialesHistoricos] = useState(null);
    const [cuestionarioIncompleto, setcuestionarioIncompleto] = useState(null);
    const [textoTemaEnCurso, settextoTemaEnCurso] = useState(null);
    const [textoButton, settextoButton] = useState(null);
    const [loadingCuestionarioActual, setLoadingCuestionarioActual] = useState(true)
    const [loadingCuestionariosHistoricos, setLoadingCuestionariosHistoricos] = useState(true);
    const generalContext = useContext(GeneralContext);
    const { t } = useTranslation();

    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const [open, setOpen] = React.useState(false);

    const handleLogout = () => {
        setAnchorElUser(null);
        logout();
        navigate("/");
        setOpen(false);
    };

    const sessionExpiredRef = useRef(false);

    function GetMisCuestionarios() {
        var cuestionarioActualPromise = getCuestionarioActual(user);
        cuestionarioActualPromise.then(
            (x) => {
                setcuestionarioIncompleto(x)
                setLoadingCuestionarioActual(false)
            },
            (y) => {
                //A�adir aqui
                console.error("Error: " + y);
            }
        );
        getCuestionarosHistoricos(user)
            .then(
                (x) => {
                    setPerfilesEmpresarialesHistoricos(x);
                    setLoadingCuestionariosHistoricos(false);
                },
                (y) => {
                    if (!sessionExpiredRef.current) {
                        sessionExpiredRef.current = true; // bloqueamos futuras alertas
                        alert("La sesi\u00F3n ha caducado. Debe iniciar sesi\u00F3n de nuevo.");
                        handleLogout();
                    }
                    console.error("Error: " + y);

                }
            );
    }
    useEffect(() => {
        user?.usuario && GetMisCuestionarios();
    }, [user]);

    //Textos para casos de uso
    useEffect(() => {
        settextoButton(t('misCuestionarios.comenzarNuevo'));
        if (cuestionarioIncompleto) {
            generalContext.setIdCuestionarioActual(
                cuestionarioIncompleto.id_cuestionario
            );
            settextoButton(t('misCuestionarios.continuar'));
            settextoTemaEnCurso(
                t('misCuestionarios.textoContinuar')
            );
        }
        else {
            settextoTemaEnCurso(
                t('misCuestionarios.textoComenzarNuevo')
            );
        }
    }, [cuestionarioIncompleto]);

    function Continuar() {
        cuestionarioIncompleto.modoCuestionario ? navigate("/Ejes") :
        navigate("/seleccionar-modo-cuestionario");
    }

    function NuevoCuestionario() {
        navigate("/crear-perfil-empresarial");
    }

    return (
        <MisCuestionariosContext.Provider value={{
            loadingCuestionarioActual,
            loadingCuestionariosHistoricos,
            GetMisCuestionarios,
            textoTemaEnCurso,
            Continuar,
            textoButton,
            cuestionarioIncompleto,
            perfilesEmpresarialesHistoricos,
            user,
            NuevoCuestionario
        }}>
            {props.children}
        </MisCuestionariosContext.Provider>
    );
}
